import { Schema } from "prosemirror-model";
import { Command, Transaction } from "prosemirror-state";

export function insertImage(
	schema: Schema<"image", never>,
	uri: string
): Command {
	return (state, dispatch): boolean => {
		if (dispatch) {
			const {
				to
			} = state.selection;

			const tr: Transaction = state.tr;
			tr.insert(
				to,
				[
					schema.nodes
						.image
						.create({
							src: uri
						})
				]
			);

			tr.scrollIntoView();
			dispatch(tr);
		}

		return true;
	};
}